import { GetPropertyByIdQuery } from 'gql/generated.graphql';

export const propertyLocationToPosition = (
  property: GetPropertyByIdQuery['getPropertyById']
) => {
  const [lng, lat] = property.location.geoLocation?.coordinates || [];
  const position = lat && lng ? { lat, lng } : { lat: 0, lng: 0 };
  return position;
};

/** here we go through all markers,
 // check if it added to cluster,
 // check if it in clusters with markers more than minimumClusterSize,
 // (it means that in this cluster markers are hidden)
 // mark it as clustered */
export const getClusteredMarkersRecord = (
  clustered: any,
  minimumClusterSize: number
): Record<string, boolean> =>
  clustered.markers.reduce(
    (
      obj: Record<string, boolean>,
      item: { title: string; isAdded: boolean }
    ) => {
      if (item.isAdded) {
        const isOnCluster = Boolean(
          clustered
            .getClusters()
            .find(
              (cl: { markers: any[] }) =>
                cl.markers.length + 1 > minimumClusterSize &&
                Boolean(
                  cl.markers.find(
                    ({ title }: { title: string }) => title === item.title
                  )
                )
            )
        );
        obj[item.title] = isOnCluster;
      }
      return obj;
    },
    {} as Record<string, boolean>
  );
